import { ChevronsUpDownIcon } from "lucide-react";
import { cn } from "../utils";

interface SelectorOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectorOption[];
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function Selector({ label, value, onChange, options, placeholder = "Not selected", disabled = false, className = "" }: SelectorProps) {
  const selectedOption = options.find((option) => option.value === value);
  const displayValue = selectedOption?.label || value || placeholder;

  return (
    <div
      className={cn(
        "group relative w-68 border-solid border-[#e0e0e0] bg-white rounded-lg border px-2",
        disabled ? "opacity-50 cursor-default" : "",
        className
      )}
    >
      <div className='flex justify-between items-center h-9.5'>
        <div className='flex items-center gap-1'>
          {label && <span className='text-gray-500 text-[11px] uppercase ml-1'>{label}:</span>}
          <span className='text-sm capitalize'>{displayValue}</span>
        </div>

        <ChevronsUpDownIcon
          size={16}
          color='#a0a0a0'
        />
      </div>

      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`absolute inset-0 opacity-0 cursor-pointer w-full ${disabled ? "cursor-default" : ""}`}
      >
        <option
          disabled
          value=''
        >
          {placeholder}
        </option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
